import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';

import { OEText } from '../../atoms/oe-text/oe-text';

export interface CircularNumberProps {
  number: number;
  backgroundColor?: string;
  fontColor?: string;
  radius?: number;
  bold: boolean;
}

export const CircularNumber: React.FC<CircularNumberProps> = ({
  number,
  backgroundColor,
  fontColor,
  radius = 34,
  bold = false,
}) => {
  return (
    <Circle radius={radius} backgroundColor={backgroundColor}>
      <Number
        radius={radius}
        fontColor={fontColor}
        fontType={bold ? 'bold' : 'medium'}
      >
        {number}
      </Number>
    </Circle>
  );
};

interface SizeProps {
  radius: number;
}
interface NumberProps extends SizeProps {
  fontColor?: string;
}
interface CircleProps extends SizeProps {
  backgroundColor?: string;
}

const Number = styled(OEText)<NumberProps>`
  font-size: 18px;
  line-height: ${({ radius }) => `${radius}px`};
  color: ${({ theme, fontColor }) => fontColor || theme.color.white};
`;

const Circle = styled.View<CircleProps>`
  width: ${({ radius }) => `${radius}px`};
  height: ${({ radius }) => `${radius}px`};
  border-radius: ${({ radius }) => `${radius / 2}px`};
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.color.primary};
`;
